import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  TextInput,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableField, DateTimeField } from "../../../../shared/fields";

const filters = [
  <TextInput key="userId" source="userId" label="User ID" alwaysOn />,
  <TextInput
    key="operatorId"
    source="operatorId"
    label="Operator ID"
    alwaysOn
  />,
];

export const UserList = () => (
  <List filters={filters} perPage={25}>
    <Datagrid bulkActionButtons={false}>
      <CopyableField source="userId" label="User ID" sortable={false} />
      <CopyableField
        source="operatorUserId"
        label="Operator User ID"
        sortable={false}
      />
      <CopyableField source="operatorId" label="Operator" sortable={false} />
      <CopyableField source="username" label="Username" />
      <TextField source="currencyCode" label="Currency" />
      <TextField source="country" label="Country" />
      <FunctionField
        label="Status"
        render={(r: { status?: string }) => <StatusChip value={r?.status} />}
      />
      <DateTimeField source="createdAt" label="Created" />
    </Datagrid>
  </List>
);
